module.exports = __webpack_public_path__ + "static/media/L2.c9ac86ab.jpeg";